export const CHECKLIST_CATEGORIAS = [
  {
    id: 'exames',
    nome: 'Exames',
    descricao: 'Confirma se os resultados estão organizados e acessíveis quando precisar.',
    recomendacao:
      'Deixe os laudos reunidos em pasta física ou digital, com senhas e links anotados.',
  },
  {
    id: 'consultas',
    nome: 'Consultas e avaliações',
    descricao: 'Verifica se as conversas médicas importantes já aconteceram.',
    recomendacao:
      'Garanta que as avaliações exigidas pelo seu cirurgião e pela anestesia estejam concluídas antes da cirurgia.',
  },
  {
    id: 'documentacao',
    nome: 'Documentação',
    descricao: 'Aponta se pedidos médicos e documentos pessoais já estão reunidos.',
    recomendacao:
      'Monte um checklist documental com tudo o que precisa ser entregue ao hospital ou convênio.',
  },
  {
    id: 'medicamentos',
    nome: 'Medicamentos',
    descricao: 'Mostra se o time médico já sabe o que você usa no dia a dia.',
    recomendacao:
      'Envie a lista completa de medicamentos, vitaminas e suplementos para orientação segura.',
  },
  {
    id: 'preparo',
    nome: 'Preparo e logística',
    descricao: 'Avalia se você já tem clareza e itens prontos para o dia da cirurgia.',
    recomendacao:
      'Confirme orientações de jejum, horários e monte sua bolsa de internação com antecedência.',
  },
]

/** Apenas "Sim" conta como preparado; "Não sei" e "Não" indicam necessidade de apoio. */
export const CHECKLIST_RESPOSTAS = [
  { valor: 'sim', rotulo: 'Sim, está em ordem', pontos: 2 },
  { valor: 'nao_sei', rotulo: 'Não sei / preciso de ajuda', pontos: 0 },
  { valor: 'nao', rotulo: 'Ainda não', pontos: 0 },
]

export const CHECKLIST_PERGUNTAS = [
  {
    id: 'exames_disponiveis',
    categoria: 'exames',
    pergunta: 'Você sabe onde estão os resultados dos seus exames e consegue acessá-los facilmente?',
    ajuda: 'Vale considerar PDF, cópia impressa e laudos com senha ou link.',
    proximoPasso: 'Organizar todos os resultados em uma pasta física ou digital de fácil acesso.',
  },
  {
    id: 'avaliacao_anestesica',
    categoria: 'consultas',
    pergunta: 'Você já recebeu orientação sobre a avaliação pré-anestésica ou sabe quando ela vai acontecer?',
    ajuda: 'Essa etapa costuma esclarecer riscos, jejum, medicações e preparo.',
    proximoPasso: 'Confirmar com a equipe médica a necessidade e o prazo da avaliação pré-anestésica.',
  },
  {
    id: 'duvidas_medicas',
    categoria: 'consultas',
    pergunta: 'Suas principais dúvidas sobre riscos, recuperação e preparo já foram esclarecidas?',
    ajuda: 'A insegurança costuma diminuir quando o plano cirúrgico está claro.',
    proximoPasso: 'Levar suas dúvidas para uma conversa estruturada com a equipe antes da cirurgia.',
  },
  {
    id: 'documentos_reunidos',
    categoria: 'documentacao',
    pergunta: 'Você já reuniu pedidos médicos, documentos pessoais e demais papéis exigidos?',
    ajuda: 'Organizar isso cedo evita correria perto da internação.',
    proximoPasso: 'Montar um checklist documental com tudo o que precisa ser entregue.',
  },
  {
    id: 'medicamentos_informados',
    categoria: 'medicamentos',
    pergunta: 'Seu médico já sabe quais medicamentos, vitaminas ou suplementos você usa atualmente?',
    ajuda: 'Alguns remédios precisam ser ajustados ou suspensos antes da cirurgia.',
    proximoPasso: 'Enviar para a equipe a lista completa de medicamentos e suplementos em uso.',
  },
  {
    id: 'orientacoes_jejum',
    categoria: 'preparo',
    pergunta: 'Você já recebeu orientações claras sobre jejum, banho, roupas e horário de chegada?',
    ajuda: 'Essas orientações variam conforme o hospital e o tipo de cirurgia.',
    proximoPasso: 'Confirmar as orientações pré-operatórias específicas para o seu procedimento.',
  },
  {
    id: 'bolsa_internacao',
    categoria: 'preparo',
    pergunta: 'Você já começou a preparar o que precisa levar para a internação ou procedimento?',
    ajuda: 'Documentos, exames, itens pessoais e roupas podem variar conforme o hospital.',
    proximoPasso: 'Montar sua bolsa de internação com antecedência e revisar os itens exigidos.',
  },
]

const NIVEIS_GERAIS = [
  {
    id: 'atencao',
    titulo: 'Precisa de atenção',
    descricao:
      'Ainda existem pontos importantes em aberto. Com orientação certa, você pode organizar o caminho antes da cirurgia.',
  },
  {
    id: 'quase_pronto',
    titulo: 'Quase pronto',
    descricao:
      'Você já avançou em etapas importantes, mas ainda há ajustes que merecem revisão para evitar surpresas.',
  },
  {
    id: 'bem_preparado',
    titulo: 'Bem preparado',
    descricao:
      'Sua preparação está em bom nível. Vale apenas validar os detalhes finais para chegar à cirurgia com mais tranquilidade.',
  },
]

const LIMIAR_BEM_PREPARADO = 0.75
const LIMIAR_QUASE_PRONTO = 0.45

function obterMetaCategoria(categoriaId) {
  return CHECKLIST_CATEGORIAS.find((categoria) => categoria.id === categoriaId)
}

function obterOpcaoResposta(valor) {
  return CHECKLIST_RESPOSTAS.find((opcao) => opcao.valor === valor)
}

function respostaIndicaPreparado(valor) {
  return valor === 'sim'
}

function obterNivelCategoria(percentual) {
  if (percentual > LIMIAR_BEM_PREPARADO) return 'Bem encaminhado'
  if (percentual > LIMIAR_QUASE_PRONTO) return 'Precisa de ajustes'
  return 'Prioridade alta'
}

function obterNivelGeral(percentual) {
  if (percentual > LIMIAR_BEM_PREPARADO) {
    return NIVEIS_GERAIS.find((nivel) => nivel.id === 'bem_preparado')
  }

  if (percentual > LIMIAR_QUASE_PRONTO) {
    return NIVEIS_GERAIS.find((nivel) => nivel.id === 'quase_pronto')
  }

  return NIVEIS_GERAIS.find((nivel) => nivel.id === 'atencao')
}

export function calcularResultadoChecklist(respostasMap) {
  const respostasNormalizadas = CHECKLIST_PERGUNTAS.map((pergunta) => {
    const valor = respostasMap[pergunta.id]
    const opcao = obterOpcaoResposta(valor) ?? CHECKLIST_RESPOSTAS[2]
    const categoria = obterMetaCategoria(pergunta.categoria)

    return {
      id: pergunta.id,
      categoriaId: pergunta.categoria,
      categoria: categoria.nome,
      pergunta: pergunta.pergunta,
      resposta: opcao.valor,
      rotulo: opcao.rotulo,
      pontos: opcao.pontos,
      pontosMaximos: 2,
      preparado: respostaIndicaPreparado(opcao.valor),
      proximoPasso: respostaIndicaPreparado(opcao.valor) ? null : pergunta.proximoPasso,
    }
  })

  const categoriasComPerguntas = CHECKLIST_CATEGORIAS.filter((categoria) =>
    CHECKLIST_PERGUNTAS.some((pergunta) => pergunta.categoria === categoria.id)
  )

  const categorias = categoriasComPerguntas.map((categoria) => {
    const respostasDaCategoria = respostasNormalizadas.filter(
      (resposta) => resposta.categoriaId === categoria.id
    )

    const score = respostasDaCategoria.reduce((total, resposta) => total + resposta.pontos, 0)
    const scoreMaximo = respostasDaCategoria.length * 2
    const percentual = scoreMaximo > 0 ? score / scoreMaximo : 0

    return {
      id: categoria.id,
      categoria: categoria.nome,
      descricao: categoria.descricao,
      recomendacao: categoria.recomendacao,
      score,
      scoreMaximo,
      percentual,
      nivel: obterNivelCategoria(percentual),
      pendencias: respostasDaCategoria
        .filter((resposta) => resposta.proximoPasso)
        .map((resposta) => resposta.proximoPasso),
    }
  })

  const scoreTotal = categorias.reduce((total, categoria) => total + categoria.score, 0)
  const scoreMaximo = categorias.reduce((total, categoria) => total + categoria.scoreMaximo, 0)
  const percentualGeral = scoreMaximo > 0 ? scoreTotal / scoreMaximo : 0
  const nivelGeral = obterNivelGeral(percentualGeral)

  return {
    scoreTotal,
    scoreMaximo,
    percentualGeral,
    nivel: nivelGeral.titulo,
    descricaoNivel: nivelGeral.descricao,
    respostas: respostasNormalizadas,
    categorias,
    proximosPassos: categorias
      .flatMap((categoria) => categoria.pendencias)
      .filter((item, index, array) => array.indexOf(item) === index)
      .slice(0, 5),
  }
}
